module.exports = __webpack_public_path__ + "static/img/A122.1b7b703f.jpg";